export const NOCTURNE_GUILD_ID = "1283861844879999066";
export const BOT_TEST_GUILD_ID = "1496054435573399663";

export const AI_ENABLED_GUILD_IDS = new Set([
  NOCTURNE_GUILD_ID,
  BOT_TEST_GUILD_ID,
]);

export const HOME_GUILD_IDS = AI_ENABLED_GUILD_IDS;

export function isAiGuild(guildId) {
  return Boolean(guildId && AI_ENABLED_GUILD_IDS.has(String(guildId)));
}

export function isHomeGuild(guildId) {
  return Boolean(guildId && HOME_GUILD_IDS.has(String(guildId)));
}
